import { LoadingOutlined } from "@ant-design/icons";
import { notification, Select, Spin, Tooltip } from "antd";
import ConfirmationModal from "components/common/Modals/ConfirmationModal";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import * as Yup from "yup";

import { InfoIcon } from "../../../components/icons";
import CloseModal from "../../../components/icons/CloseModal";
import {
  ASPECT_RATIO,
  EVENT_NAME,
  MOSES_BUCKET_NAME,
  SUPPORTED_ASPECTRATIO_FOR_CLIP_UPLOAD,
  SUPPORTED_ASPECTRATIO_FOR_SHOT_UPLOAD,
  SYNCING_STATUS,
} from "../../../constants/phase";
import amplitude from "../../../externals/amplitude";
import { uploadToS3Validation } from "../../../utils/validations";

const { Option } = Select;

const UploadToS3 = (props) => {
  const { clientSetting, entityId } = useOutletContext();
  const {
    s3Open,
    setS3Open,
    clip,
    loder,
    s3BucketPublish,
    storage,
    streamDetails,
    bucketCopy,
    bulkS3BucketPublish,
    folderArray,
    setFolderArray,
    getClipSizeByUrl,
    filters,
    setLoder,
    refreshClips,
  } = props;
  const [multipleStorageArr, setMultipleStorageArr] = useState([]);
  const [uploadToS3Validations, setUploadToS3Validations] = useState(uploadToS3Validation);
  const [initialState, setInitialState] = useState({
    storageName: "",
    folderPath: "",
    folderPaths: [],
  });
  const [disable, setDisable] = useState(true);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [bucketAction, setBucketAction] = useState("copy_bucket");
  const [stName, setStName] = useState("");
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [submitedValues, setSubmitedValues] = useState({});

  const { storageName } = initialState;

  useEffect(() => {
    if (clientSetting?.permissions?.multiFolderUpload && !folderArray?.length) {
      setUploadToS3Validations(
        Yup.object().shape({
          // storage_name: Yup.string().required("Required"),
          folderPaths: Yup.array().min(1).required("Required"),
        }),
      );
    }
  }, [clientSetting?.permissions?.multiFolderUpload, folderArray?.length]);

  useEffect(() => {
    if (folderArray?.length) {
      setButtonDisable(true);
      handleClipSizeByUrl();
    }
  }, [folderArray?.length]);

  const uploadAgain = async ({ storageName, folderPath }, folderPaths) => {
    const data = await bulkS3BucketPublish({
      storageId: storage.filter(({ storage_name }) => storage_name === storageName)[0]?._id,
      folderPath: folderPath,
      fileUrls: folderPaths,
      streamId: streamDetails?.streamId,
    });
    if (data.value.success || data.value.status) {
      notification["success"]({ message: data.value.message });
    } else {
      notification["error"]({
        message: data.value.message,
        duration: 5,
        description: (
          <>
            <a
              style={{ textDecoration: "underline", fontSize: "12px" }}
              onClick={() => uploadAgain({ storageName, folderPath }, folderPaths)}
            >
              Upload again
            </a>
            <br></br>
            <ul>
              {data.value.data.map((d) => (
                <li style={{ fontSize: "10px" }} key={d}>
                  {d}
                </li>
              ))}{" "}
            </ul>
          </>
        ),
      });
    }
  };
  const handleSubmit = async (values) => {
    const { storageName, folderPath, folderPaths } = values;
    amplitude.logEvent("cloud_publish_triggered", {
      page: "clip",
    });
    const { uploadToThirdPartyS3Publish } = props;
    if (folderArray?.length) {
      notification["success"]({ message: "Process Initiated..." });
      let videoUrls = folderArray?.map(
        (obj) =>
          obj?.editedVideos?.find(
            ({ aspect_ratio, event }) =>
              aspect_ratio === filters?.aspectRatio && (event === "autoFlip" || event === "croppedVideos"),
          )?.video_url || obj.videoUrl,
      );

      const data = await bulkS3BucketPublish({
        storageId: storage.filter(({ storage_name }) => storage_name === storageName)[0]._id,
        folderPath: folderPath,
        fileUrls: videoUrls,
        streamId: streamDetails?.streamId,
      });
      if (data.value.success || data.value.status) {
        notification["success"]({ message: data.value.message });
        setFolderArray([]);

        amplitude.logEvent("cloud_publish_succeeded", {
          page: "clip",
          type: "bulk",
        });
      } else {
        notification["error"]({
          message: data.value.message,
          duration: 5,
          description: (
            <>
              <a
                style={{ textDecoration: "underline", fontSize: "12px" }}
                onClick={() => uploadAgain({ storageName, folderPath }, data?.value?.data)}
              >
                Upload again
              </a>
              <ul>
                {data.value.data.map((d) => (
                  <li style={{ fontSize: "10px" }} key={d}>
                    {d}
                  </li>
                ))}
              </ul>
            </>
          ),
        });

        amplitude.logEvent("cloud_publish_failed", {
          page: "clip",
          type: "bulk",
        });
      }
    } else {
      let clipData = clip?.editedVideos?.find(
        ({ aspect_ratio, event, status }) =>
          aspect_ratio === filters?.aspectRatio && event !== EVENT_NAME.DYNAMIC && status !== SYNCING_STATUS.PROCESSING,
      );
      const bucket = storage.filter(({ storage_name }) => storage_name === storageName)?.[0] || {};

      if (clientSetting?.permissions?.isThirdPartyS3 && bucket.isMosesBucket) {
        if (clip?.aspectRatio !== ASPECT_RATIO["16_9"]) {
          notification.error({
            message: "Clips are missing in 9:16 and 3:4 aspect ratio.",
          });
          refreshClips(false);
          closeModal();
          return;
        }
        if (clip?.episodeTitle === "") {
          notification.error({ message: "Clip's title is mandatory to publish the clip" });
          refreshClips(false);
          closeModal();
          return;
        }

        if (folderPath.includes("SHORTS")) {
          const isSupportedAspectRatioPresent = SUPPORTED_ASPECTRATIO_FOR_SHOT_UPLOAD.every((supportedRatio) =>
            clip?.editedVideos?.some(
              ({ aspect_ratio, event, status }) =>
                aspect_ratio === supportedRatio && event !== EVENT_NAME.DYNAMIC && status !== SYNCING_STATUS.PROCESSING,
            ),
          );

          const is9_18AspectRatio = filters?.aspectRatio === ASPECT_RATIO["9_18"];

          if (!is9_18AspectRatio) {
            notification.error({ message: "SHOT can only be published with clips having a 9:18 ratio." });
            refreshClips(false);
            closeModal();
            return;
          }

          if (is9_18AspectRatio && !isSupportedAspectRatioPresent) {
            notification.error({
              message:
                "Please generate clips with aspect ratios of 9:16 and 3:4 for the publication of SHOT in the required 9:18 ratio.",
              duration: 5,
            });
            refreshClips(false);
            closeModal();
            return;
          }
        } else if (!SUPPORTED_ASPECTRATIO_FOR_CLIP_UPLOAD.includes(filters?.aspectRatio || ASPECT_RATIO["16_9"])) {
          notification.error({ message: "Uploading clips in the selected aspect ratio is not allowed." });
          refreshClips(false);
          closeModal();
          return;
        }
      }

      notification["success"]({ message: "Process Initiated..." });
      let payload = {
        bucket,
        streamId: clip?.streamId,
        folderPath: folderPath,
        folderPaths,
        fileUrl: clipData?.video_url || clip.videoUrl,
        aspectRatio: clipData ? clipData?.aspect_ratio : clip.aspectRatio || ASPECT_RATIO["16_9"],
        clipId: clip._id,
        isMultiFolderUpload: folderPaths.length > 0,
        isGameChanger: clientSetting?.permissions?.exportXMP ? true : false,
      };
      closeModal();
      const data =
        clientSetting?.permissions?.isThirdPartyS3 && MOSES_BUCKET_NAME.includes(storageName)
          ? (delete payload.isGameChanger,
            await uploadToThirdPartyS3Publish({
              ...payload,
              aspectRatio: filters?.aspectRatio || ASPECT_RATIO["16_9"],
              videoThumbnailUrl: clipData?.thumbnailUrl || clip?.videoThumbnailUrl,
              clipTitle: clip?.episodeTitle || "",
            }))
          : await s3BucketPublish(payload);
      if (data.value.success || data.value.status) {
        notification["success"]({ message: data.value.message });
        amplitude.logEvent("cloud_publish_succeeded", {
          page: "clip",
          type: "single",
        });
      } else {
        notification["error"]({ message: data.value.message });
        amplitude.logEvent("cloud_publish_failed", {
          page: "clip",
          type: "single",
          error: data?.value?.message,
        });
      }
    }
    refreshClips();
  };
  const handleClipSizeByUrl = async () => {
    const data = await getClipSizeByUrl({
      fileUrls: folderArray.map((d) => d.videoUrl),
    });

    if (data?.value?.size > 524288000) {
      notification["error"]({ message: "Download file size shouldn't exceed 500 mb" });
      setButtonDisable(true);
    } else {
      setButtonDisable(false);
    }
  };
  const closeModal = () => {
    setS3Open(false);
    setMultipleStorageArr([]);
    // setFolderArray([]);
    setInitialState({
      storageName: "",
      folderPath: "",
      folderPaths: [],
    });
  };

  const bucketActions = async () => {
    if (bucketAction == "copy_bucket") {
      const data = await bucketCopy({
        bucket: storage.filter((data) => data.storage_name === stName)[0],
        folderPath: `${streamDetails?.entityId || entityId}/${streamDetails?.streamId}/`,
        urlArr: [clip?.videoUrl, clip?.videoThumbnailUrl],
        id: clip?.id,
        sourceBuket: streamDetails?.config?.storage?.credentials?.bucket_name,
        sourceAccessKey: streamDetails?.config?.storage?.credentials?.access_key,
        sourceSecretAccessKey: streamDetails?.config?.storage?.credentials?.secret_key,
        sourceRegion: streamDetails?.config?.storage?.credentials?.region,
        sourceCdnSuffix: streamDetails?.config?.storage?.credentials?.cdn_suffix,
      });
    } else {
      var payload = {
        bucket: storage.filter((data) => data.storage_name === stName)[0],
        folderPath: `${streamDetails?.entityId || entityId}/${streamDetails?.streamId}/`,
        urlArr: [clip?.videoUrl, clip?.videoThumbnailUrl],
        id: clip?.id,
      };
    }
  };

  //to set folderpath with respect to storage name selected
  const setBucketValue = (setFieldValue, value) => {
    setFieldValue("folderPaths", []);
    setFieldValue("storageName", value);
    if (value === "default") {
      setFieldValue("folderPath", "");
      setMultipleStorageArr([]);
      setDisable(true);
    } else {
      setDisable(false);
    }
    setStName(value);
    var temp = [];
    storage.filter((obj) => {
      if (obj.storage_name === value) {
        setFieldValue("folderPath", obj?.credentials?.folder_path);
        temp = obj?.multiple_folder_path || [];
        setMultipleStorageArr(temp);
      } else if (value === "") {
        setMultipleStorageArr([]);
        setFieldValue("folderPath", "");
      }
    });
  };
  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
    closeModal();
  };
  const handleConfirmationAndSubmit = () => {
    handleSubmit(submitedValues);
    setOpenConfirmationModal(false);
  };
  const handleConfirmationModal = (values) => {
    setSubmitedValues(values);
    setOpenConfirmationModal(true);
  };

  return (
    <>
      {openConfirmationModal && (
        <ConfirmationModal
          isOpen={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          header={"Cloud Publish Confirmation"}
          content={"This clip has already been published. Do you want to publish it again?"}
          onConfirm={handleConfirmationAndSubmit}
          btnName={"Yes"}
        />
      )}
      <Modal
        isOpen={s3Open}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Cloud Publish"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-sm modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">
              Cloud Publish
              <Tooltip placement="topLeft" title={`Max files: 5 files or Max size: 500MB`}>
                <InfoIcon className="info-icon-main" />
              </Tooltip>
            </h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik
            initialValues={initialState}
            validationSchema={uploadToS3Validations}
            onSubmit={(values) =>
              values.folderPath.includes("SHORTS") && clip?.asset_id && MOSES_BUCKET_NAME.includes(values.storageName)
                ? handleConfirmationModal(values)
                : handleSubmit(values)
            }
            enableReinitialize
          >
            {({ errors, touched, setFieldValue, values, dirty }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container row">
                    <div className="form-group">
                      <label className="form-label">
                        Storage <span className="required">*</span>
                      </label>
                      <select
                        className="custom-select form-control"
                        name="storageName"
                        onChange={(e) => setBucketValue(setFieldValue, e.target.value)}
                      >
                        <option value="default">Select Storage</option>
                        {storage &&
                          storage
                            .filter(({ storage_type }) => storage_type !== "medialive")
                            .map((data) => {
                              return (
                                <option key={data._id} value={data.storage_name}>
                                  {data.storage_name}
                                </option>
                              );
                            })}
                      </select>
                    </div>
                    {clientSetting?.permissions?.multiFolderUpload && !folderArray?.length ? (
                      <>
                        <div className="form-group">
                          <label className="form-label">
                            Select Folder Paths <span className="required">*</span>
                          </label>
                          <div className="form-pop-trigger-block">
                            <Field
                              className="custom-ant-select"
                              name="folderPaths"
                              onChange={(e) => setFieldValue("folderPaths", e)}
                              component={Select}
                              dropdownStyle={{ zIndex: 99999999 }}
                              mode="multiple"
                              placeholder="Select Paths"
                              showSearch
                              value={values?.folderPaths || []}
                            >
                              {multipleStorageArr?.map((data) => {
                                return (
                                  <Option key={data._id} value={data.multiple_folder_path}>
                                    {data.multiple_folder_path}
                                  </Option>
                                );
                              })}
                            </Field>
                            {touched.folderPaths && errors.folderPaths && (
                              <div className="invalid-feedback">Must have at least 1 path</div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {multipleStorageArr?.length > 1 ? (
                          <div className="form-group">
                            <label className="form-label">
                              Select Folder Path <span className="required">*</span>
                            </label>
                            <select
                              className="custom-select form-control"
                              value={values.folderPath}
                              name="folderPath"
                              onChange={(e) => setFieldValue("folderPath", e.target.value)}
                            >
                              <option value="">Select Option</option>
                              {multipleStorageArr?.map((data, index) => {
                                return (
                                  <option key={index} value={data.multiple_folder_path}>
                                    {data.multiple_folder_path}
                                  </option>
                                );
                              })}
                            </select>
                            {touched.folderPath && errors.folderPath && (
                              <div className="invalid-feedback">{errors.folderPath}</div>
                            )}
                          </div>
                        ) : (
                          <div className="form-group">
                            <label className="form-label">
                              Folder Path <span className="required">*</span>
                            </label>
                            <Field type="text" className="form-control" name="folderPath" />
                            {touched.folderPath && errors.folderPath && (
                              <div className="invalid-feedback">{errors.folderPath}</div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <button type="button" className="btn btn-white" onClick={closeModal}>
                    Cancel
                  </button>
                  <button disabled={!dirty || disable || buttonDisable} className="btn btn-primary" type="submit">
                    Submit
                    {buttonDisable ||
                      (loder && (
                        <Spin
                          size="large"
                          indicator={
                            <LoadingOutlined
                              style={{
                                fontSize: 50,
                                color: "#000",
                                marginLeft: 50,
                              }}
                              spin
                            />
                          }
                          className="loader__full"
                        ></Spin>
                      ))}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default UploadToS3;
